import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import ReactsCard from "../../components/ui/ReactsCard";
import {Button} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {OrganizationsTableConnected} from "./organization/OrganizationsTableConnected";


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 250,
        margin: theme.spacing(4)
    },
    action: {
        justifyContent: 'flex-end'
    },
    table: {
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'center'
    }
}));


export const OrganizationsTablePicker = ({
    onSelect,
    ...props
}: any) => {
    const classes = useStyles();
    const {t} = useTranslation();

       const actions = (o: any) => <Button color="primary" size="small"
                                 disabled={props.selected?.id === o.id}
                                 onClick={() => onSelect(o)}>
        {props.selected?.id === o.id ? t('_Common.Labels.Selected') : t('_Common.Labels.Open')}
    </Button>

    return (
               <ReactsCard title={t('Organizations.Title')} className={classes.root}>
                        <div className={classes.table}>
                                <Grid container spacing={3}>
                                        <Grid container item xs={12}>
                                                <OrganizationsTableConnected {...props} actions={actions}/>
                    </Grid>
                </Grid>
            </div>
        </ReactsCard>
    )
};
